/**
 * Intelligence product feature visibility (compile-time + runtime product-status).
 * Keep REACT_APP_INTELLIGENCE_ENABLED=false until GA; product-status still unlocks preview orgs.
 *
 * Telegram is an Intelligence channel (same agent / credits), so admin setup and
 * the customer bot follow productEnabled — not a separate feature flag.
 */

export const isIntelligenceBuildEnabled = (): boolean =>
  String(process.env.REACT_APP_INTELLIGENCE_ENABLED || '')
    .trim()
    .toLowerCase() === 'true';

export const isIntelligenceProductLive = (
  status: { productEnabled?: boolean } | null | undefined
): boolean => Boolean(status?.productEnabled);
